<template>
    <grouped-radio-button-field
        v-bind="$props"
        @update:model-value="select($event)"
    />
</template>

<script>
import AbstractGroupedField from '@/views/order/lenses/fields/AbstractGroupedField.vue';
import GroupedRadioButtonField from '@/views/order/lenses/fields/GroupedRadioButtonField.vue';
import useDesignLevelComposable from '@/composables/DesignLevelComposable';

export default
{
    name: 'DesignLevel',

    components:
    {
        GroupedRadioButtonField,
    },

    extends: AbstractGroupedField,

    emits: ['update:modelValue'],

    setup(props, { emit })
    {
        const {
            select,
        } = useDesignLevelComposable(props, emit);

        return {
            select,
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
